import { Pipe, PipeTransform, inject } from '@angular/core';
import { I18nArrayValuePipe } from '../i18n-array-value/i18n-array-value.pipe';
import { StackOrderOptions } from './model/stack-order-options.model';

@Pipe({
	name: 'stackOrder',
	pure: false
})
export class StackOrderPipe implements PipeTransform {
	private i18nArrayValuePipe = inject(I18nArrayValuePipe);

	transform(values: any[], options: StackOrderOptions): any {
		if (!values) return values;

		let stacks = [...values];

		if (options.stack) {
			stacks = stacks.filter((_) => _.id != options.stack.id);
			if (!options.displayFirst) {
				stacks.unshift(options.stack);
			}
		}

		stacks = stacks.sort((a, b) =>
			this.i18nArrayValuePipe.transform(b.i18nTitles, options.language) <
			this.i18nArrayValuePipe.transform(a.i18nTitles, options.language)
				? 1
				: this.i18nArrayValuePipe.transform(
							b.i18nTitles,
							options.language
					  ) >
					  this.i18nArrayValuePipe.transform(
							a.i18nTitles,
							options.language
					  )
					? -1
					: 0
		);

		stacks = stacks.sort(
			(a, b) =>
				(a.displayOrder ?? Infinity) - (b.displayOrder ?? Infinity)
		);

		if (options.stack) {
			if (options.displayFirst) {
				stacks.unshift(options.stack, options.stack);
			}
		}

		return stacks;
	}
}
